import { images } from "./Assets/assetsHelper";

// AI Develop
const config = {
  API_BASE_URL: "https://apistaging.the-aichallenge.com",
  REG_LINK: "https://the-aichallenge.com/firststage",
  APP_ENV: "develop",
  APP_NAME: "AI Reg",
  DEFAULT_LANGUAGE: "en",
  PRIMARY_COLOR: "hsl(250 80% 65%)",
  SECONDARY_COLOR: "#fff",
  APP_LOGO: images.Company_Logo_Hor,
};

// AI Production
// const config = {
//   API_BASE_URL: "https://api.the-aichallenge.com",
//   REG_LINK: "https://the-aichallenge.com/firststage",
//   APP_ENV: "production",
//   APP_NAME: "AI Reg",
//   DEFAULT_LANGUAGE: "en",
//   PRIMARY_COLOR: "hsl(250 80% 65%)",
//   SECONDARY_COLOR: "#fff",
//   APP_LOGO: images.Company_Logo_Hor,
// };

export default config;
